// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"11":"b43b6c29","285":"f62bb741","486":"84f9740a","786":"b737ff3e","805":"3aa2c48f"}[chunkId] + ".chunk.js";
};